import { Res } from 'common/types/responses'
import { Req } from 'common/types/requests'
import { service } from 'common/service'
import { getUser } from './useUser'
import { getStore } from 'common/store'

export const addressService = service
  .enhanceEndpoints({ addTagTypes: ['Address', 'Company'] })
  .injectEndpoints({
    endpoints: (builder) => ({
      changeForwardAddress: builder.mutation<
        Res['changeForwardAddress'],
        Req['changeForwardAddress']
      >({
        invalidatesTags: [],
        query: (query: Req['changeForwardAddress']) => {
          const { subscription_id, ...body } = query
          return {
            body,
            method: 'PUT',
            url: `/customers/subscriptions/${subscription_id}`,
          }
        },
        transformResponse: async (response: Res['changeForwardAddress']) => {
          await getUser(getStore(), {}, { forceRefetch: true })
          return response
        },
      }),

      updateSubscriptionLocation: builder.mutation<
        Res['updateSubscriptionLocation'],
        Req['updateSubscriptionLocation']
      >({
        invalidatesTags: [{ id: 'LIST', type: 'Company' }],
        query: (query: Req['updateSubscriptionLocation']) => ({
          body: {},
          method: 'PUT',
          url: `/customers/subscriptions/${query.subscription_id}/locations`,
        }),
        transformResponse: async (
          response: Res['updateSubscriptionLocation'],
        ) => {
          await getUser(getStore(), {}, { forceRefetch: true })
          return response
        },
      }),

      // END OF ENDPOINTS
    }),
  })

export async function changeForwardAddress(
  store: any,
  data: Req['changeForwardAddress'],
  options?: Parameters<
    typeof addressService.endpoints.changeForwardAddress.initiate
  >[1],
) {
  return store.dispatch(
    addressService.endpoints.changeForwardAddress.initiate(data, options),
  )
}
// END OF FUNCTION_EXPORTS

export const {
  useChangeForwardAddressMutation,
  useUpdateSubscriptionLocationMutation,
  // END OF EXPORTS
} = addressService

/* Usage examples:
const { data, isLoading } = useGetAddressQuery({ id: 2 }, {}) //get hook
const [createAddress, { isLoading, data, isSuccess }] = useCreateAddressMutation() //create hook
*/
